import React from 'react';
import {notify} from 'react-notify-toast';
import firebase from 'firebase';
import Display from '../helpers/display';
import GoogleAnalytics from 'react-ga';
import uuid from 'uuid/v4';

class Transact extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			initiated:false,
			from: null,
			fromWallet: null,
			to: null,
			toWallet: null,
			profiles: null,
			amount: '',
			education: '0'
		}
		this.closeCallback = this.closeCallback.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.addTransaction = this.addTransaction.bind(this);
	}

	componentDidMount() {
		this.updateState(this.props);
	}

	componentDidUpdate(newProps) {
		// Process any props updates
		if (newProps !== this.props) {
			this.updateState(newProps);
		}
	}

	updateState(props) {
		// Calculate the wallet total of each.
		this.setState({
			fromWallet: Display.walletTotal(props.profiles[props.from].transactions)
		})
		this.setState({
			toWallet: Display.walletTotal(props.profiles[props.to].transactions)
		})
		this.setState({
			education: Number(props.profiles[props.to].education)
		})
	}

	renderTypeHeadings(type) {
		let headings = {
			'send': 'Send money to',
			'take': 'Take money from',
			'educate': 'Update Education'
		}
		return headings[type];
	}

	renderTransactionDescriptions(props, state, notification) {
		// console.log('renderTransactionDescriptions',props, state, state.education)
		let descriptions = {
			send: `${notification
				? 'You'
				: props.profiles[props.from].name} sent $${state.amount} to ${props.profiles[props.to].name}`,
			take: `${notification
				? 'You'
				: props.profiles[props.from].name} took $${state.amount} from ${props.profiles[props.to].name}`,
			educate: `Education update for ${props.profiles[props.from].name}" to "${Display.educationName(state.education)}" costing $${state.amount}`
		}
		return descriptions[props.type];
	}

	addTransaction(type, amount) {
		const id = uuid();
		GoogleAnalytics.plugin.execute('ecommerce', 'addTransaction', {
			id: id,
			revenue: Math.abs(amount),
		});
		GoogleAnalytics.plugin.execute('ecommerce', 'addItem', {
			id: id,
			sku: id,
			name:this.renderTransactionDescriptions(this.props, this.state, true),
			category:type,
			price: Math.abs(amount),
			quantity: 1
		});
		GoogleAnalytics.plugin.execute('ecommerce', 'send');
	}

	closeCallback() {
		this.props.callback('close');
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;

		// Limit transaction amounts
		if (name === 'amount' && Math.abs(value) > 9999) {
			notify.show('The maximum transfer size is $9,999', 'error')
			return;
		}

		this.setState({[name]: value});
	}

	handleSubmit(event) {
		event.preventDefault();

		if(this.state.initiated) {
			notify.show('Transfer in progress, check your internet connection.', 'error');
			return false;
		}

		this.setState({'initiated':true});

		let amount = Math.floor(this.state.amount),
			date = new Date().getTime();

		// Prevent small transactions
		if (this.props.type !== 'educate' && amount <= 0) {
			notify.show('Transfers must be $1 or more', 'error');
			return;
		} else if (this.props.type === 'educate' && amount < 0) {
			notify.show('Amounts must be $1 or more', 'error');
			return;
		}

		// Prevent transfers that send wallets into negative
		if (this.props.type === 'send' && this.props.profiles[this.props.from].permission === 'participant' && this.state.fromWallet < amount) {
			notify.show(`You don't have enough money for that transaction`, 'error');
			return;
		}

		// For taking money and education updates, if the receiver doesn't have enough in their account, don't transact.
		if (this.props.type !== 'send' && amount && this.state.toWallet < amount) {
			notify.show(`${this.props.profiles[this.props.to].name} does not have enough money for that transaction`, 'error');
			return;
		}

		// Handle send/take as positive or negative amounts
		if (this.props.type === 'take' || this.props.type === 'educate')
			amount = -amount;

		let receiverTransaction = {
			amount: amount,
			description: this.renderTransactionDescriptions(this.props, this.state, false),
			created: date
		}

		let senderTransaction = {
			amount: -amount,
			description: this.renderTransactionDescriptions(this.props, this.state, false),
			created: date
		}

		// console.log('create education', this.state, this.state.education, Number(this.state.education))

		let educationUpdate = {
			education: Number(this.state.education),
			educationUpdated: new Date().getTime()
		}

		// console.log('handleSendMoneySubmit', this.props.game.id, receiverTransaction, senderTransaction, educationUpdate);

		firebase.database().ref(`profiles/${this.props.game.id}/${this.props.to}/transactions/`).push().set(receiverTransaction).then(response => {
			firebase.database().ref(`profiles/${this.props.game.id}/${this.props.from}/transactions/`).push().set(senderTransaction).then(response => {
				if (this.props.type === 'educate') {
					firebase.database().ref(`profiles/${this.props.game.id}/${this.props.to}`).update(educationUpdate).then(response => {
						notify.show(this.renderTransactionDescriptions(this.props, this.state, true), 'success');
						this.addTransaction('education', amount);
						this.closeCallback();

						GoogleAnalytics.event({
							category: 'Interaction',
							action: 'UpdateEducation',
							label: this.props.gameId,
							nonInteraction: false
						});

					}).catch(error => {
						notify.show('Could not update education', 'error');
						console.warn('Error updating education', error);
						GoogleAnalytics.event({
							category: 'Error',
							action: 'UpdateEducationError',
							label: 'Education save fail from ' + this.props.from,
							nonInteraction: false
						});
					})

				} else {
					notify.show(this.renderTransactionDescriptions(this.props, this.state, true), 'success');
					this.addTransaction('transfer', amount);
					this.closeCallback();
				}
			}).catch(error => {
				notify.show('Could not send money', 'error');
				console.warn('Error sending money', error);
				GoogleAnalytics.event({
					category: 'Error',
					action: 'TransferError',
					label: 'From transaction save fail',
					nonInteraction: false
				});

			})
		}).catch(error => {
			notify.show('Count not send money', 'error');
			console.warn('Error sending money', error);
			GoogleAnalytics.event({
				category: 'Error',
				action: 'TransferError',
				label: 'To transaction save fail',
				nonInteraction: false
			});
		})
	}

	render() {

		return <aside className="overlay">

			{/* { this.props.type === 'send' && this.renderSendMoney()} */}

			<form onSubmit={this.handleSubmit}>
				<h4>{this.renderTypeHeadings(this.props.type)}</h4>
				<h2>{this.props.profiles[this.props.to].name}</h2>
				<h3>${this.state.toWallet}
					{this.props.type === 'educate' && ` - ${Display.educationName(this.props.profiles[this.props.to].education)}`}</h3>

				{
					this.props.type === 'educate' && <div className="field">
							<label>Set Education Level</label>
							<select name="education" onChange={this.handleInputChange}>
								<option selected={this.state.education === 0
										? 'selected'
										: null} value="0">No Education</option>
								<option selected={this.state.education === 1
										? 'selected'
										: null} value="1">Primary School</option>
								<option selected={this.state.education === 2
										? 'selected'
										: null} value="2">High School</option>
								<option selected={this.state.education === 3
										? 'selected'
										: null} value="3">University</option>
							</select>
						</div>
				}

				<div className="field -prepend">
					<label>{
							this.props.type === 'educate'
								? 'Optional Cost'
								: 'Amount'
						}</label>
					<span className="prepend">$</span>
					<input name="amount" type="number" value={this.state.amount} placeholder="Amount" onChange={this.handleInputChange} min={this.props.type === 'educate'
							? 0
							: 1} max="9999" step="1"/>
				</div>

				<button type="submit" className="button -huge -primary -icon -send">
					{
						this.props.type === 'educate'
							? 'Educate for '
							: this.props.type + ' '
					}
					${this.state.amount || 0}</button>

				{
					this.props.profiles[this.props.from].permission === 'participant' && <p className="fineprint">You have <span>${this.state.fromWallet}</span>
							in your account</p>
				}
			</form>

			<a className="close" onClick={this.closeCallback}>
				<span>Cancel</span>X
			</a>

		</aside>
	}
}

export default Transact



// WEBPACK FOOTER //
// ./src/components/game/transact.js